/* eslint-disable  */
import { yupResolver } from "@hookform/resolvers/yup";
import Image from "next/image";
import { useForm } from "react-hook-form";
import * as yup from "yup";

import DgHerosGoldIcon from "@/assets/images/icons/downloadThis.svg";
import primaryCTA from "@/assets/images/icons/Primary-CTA_Large.svg";
import { useRouter } from "next/router";
// import DgHerosGoldIcon from "@/assets/images/icons/dgHerosGoldIcon.svg";
import routes from "@/routes/routes.json";
import DgInaugralBannerImage from "@/assets/images/icons/dg_inaugral_banner.svg";
import { createMoengageEvent } from '@/utils/moengage';
import useMoengageStore from '@/store/moengage';
import moment from 'moment';

export const HomeHero = () => {
  const phoneRegex: RegExp = /^[6-9][0-9]{9}$/;
  const phoneSchema = yup.object({
    phoneNumber: yup
      .string()
      .required("*Required")
      .matches(phoneRegex, "Enter Valid Phone Number"),
  });
  const router = useRouter();
  const {
    register: formRegister,
    formState: { errors: phoneErros },
    handleSubmit,
  } = useForm({
    defaultValues: {
      phoneNumber: "",
    },
    resolver: yupResolver(phoneSchema),
  });
  const {dgBuyNowClicked} = useMoengageStore((state) => (state.dgBuyNowClicked));
  const onSubmitPhone = () => {
    // console.log(data,"data")
  };
  const onSubmit = () => {
    createMoengageEvent(dgBuyNowClicked, {
      created_date: moment().format('MMMM Do YYYY, h:mm:ss a'),
      service_type: 'dg'
    })
    router.push(routes.buyGoldLanding);
  };
  return (
    <section className="bg bg--dark home__hero dg">
      <div className="dg-home-gold-icon container">
        <div className="row justify-content-lg-">
          <div className="col-lg-6">
            <h1 className="text--white mfo-dg-landing-section_title">
              Grow Your <br /> Investments With eSwarna Digital Gold
            </h1>
            <h2 className="mfo-dg-landing-section_small text--white mt-3">
              Start with as little as Re. 1
            </h2>
            {/* <form autoComplete="off" onSubmit={handleSubmit(onSubmitPhone)}>
              <div className="home__hero__form-row">
                <div className="hero-custom-input">
                  <span className="text--semi">+91</span>
                  <input
                    type="number"
                    placeholder="Enter 10-digit phone number"
                    {...formRegister("phoneNumber")}
                  />
                </div>
                //  <a href="#" className="custom__button custom__button--dark">
                //   Get App
                // </a> 
                <button
                  type="submit"
                  className="custom__button custom__button--dark"
                >
                  Get App
                </button>
              </div>
              {phoneErros.phoneNumber && (
                <p className="text--semi errorMessage withInfo showError">
                  {phoneErros.phoneNumber.message}
                </p>
              )}
            </form> */}
            <div className="d-flex align-items-center">
              {/* {/* <a
                href="https://play.google.com/store/apps/details?id=com.muthootfincorpone.superapp"
                target="_blank"
                id="digital-gold_play-store"
              >
                <Image 
style={{ color: undefined }}
                  // width={32}
                  // height={32}
                  // className="img-fluid"
                  src={primaryCTA}
                  alt="Google Play Store"
                /> }
                <span className="sr-only">Buy Now</span>
              </a> */}

              <button
                type="submit"
                className="mfo-dg-landing-custom_button text--bold"
                id="digital-gold_buy-now"
                onClick={onSubmit}
              >
                Buy Now
              </button>
            </div>
            <div className="d-flex align-items-center">
              <p className="mfo-dg-landing-terms_text text--white mt-1` "></p>
            </div>
          </div>
          {/* <div className="col-lg-2"></div> */}
          <div className="col-lg-4">
            <Image
              style={{ color: undefined }}
              src={DgInaugralBannerImage}
              height={756}
              width={756}
              // style={{top:-60}}
              // height={556}
              // width={856}
              // style={{
              //   position: 'absolute',
              //   zIndex: 0,
              //   top: '-35%',
              //   left: '-5%',
              // }}
              className="dg_inaugral-banner-image"
              alt="download-app"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
